import React, { useState } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';

const Example = (props) => {
    let color = props.color;
    let style = props.style;

    return (
        <div id="tooltip" className="tooltip-leyenda" style={style}>
            <SvgAssets icon="icon-info" fill={color}/>
            <UncontrolledTooltip placement="left" target="tooltip" className="tooltip-leyenda">
                <span>PVD: Precio Venta Dealer</span>
                <span>PVP: Precio Venta Público</span>
            </UncontrolledTooltip>
        </div>
    );
}

export default Example;